export default "__VITE_PUBLIC_ASSET__3340c0c6__"